import React, { useMemo, useRef } from 'react';
import { Box, Typography } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import { dayOffColor, holidayColor } from "src/constants/colors";

import { getDateMonthForYear } from "../../../../utils/calendar";

import { Day } from "./components";

interface MonthCalendarProps {
  month: string;
  year: number;
  workTimePeriod: any;
  holidayPeriod: any;
  dayOffPeriod: any;
}

export function Month({
  month,
  year,
  workTimePeriod,
  holidayPeriod,
  dayOffPeriod,
}: MonthCalendarProps) {
  const referenceDate = useMemo(
    () => dayjs(getDateMonthForYear(year.toString(), month)),
    [year, month]
  );

  return (
    <Box
      sx={{
        marginTop: "32px",
        marginRight: "32px",
      }}
    >
      <Typography
        sx={{
          fontWeight: "600",
          marginLeft: "5px",
          marginBottom: "12px",
          color: "#676767",
          textTransform: "uppercase",
          fontSize: "13px",
        }}
      >
        {month}
      </Typography>
      <DateCalendar
        showDaysOutsideCurrentMonth
        fixedWeekNumber={6}
        views={["day"]}
        slots={{
          day: Day,
        }}
        slotProps={{
          day: {
            workTimePeriod,
            holidayPeriod,
            dayOffPeriod,
          } as any,
        }}
        referenceDate={referenceDate}
        reduceAnimations
        readOnly
        sx={{
          maxHeight: "232px",
          maxWidth: "252px",

          "& .MuiPickersCalendarHeader-root": {
            display: "none",
          },

          "& .MuiDayCalendar-header": {
            borderBottom: "1px solid #F3F3F3",

            "& .MuiDayCalendar-weekDayLabel": {
              height: "32px",
              width: "32px",
              margin: "0px",
              marginLeft: "4px",
              fontWeight: "700",
              fontSize: "11px",
              color: "#828282",
              cursor: "default",
              userSelect: "none",

              "&:first-of-type": {
                marginLeft: "0px",
                marginRight: "2px",
              },

              "&:last-child": {
                marginLeft: "6px",
              },
            },
          },

          "& .MuiPickersDay-root:focus, & .MuiPickersDay-root:hover": {
            backgroundColor: "transparent",
          },

          "& .Mui-selected:hover, & .Mui-selected:focus": {
            backgroundColor: "#BF295C",
          },

          "& .Mui-selected.MuiButtonBase-root": {
            color: "#FFFFFF",
          },

          "& .MuiButtonBase-root": {
            margin: "0px 6px",
            width: "24px",
            height: "24px",
            fontSize: "11px",
            fontWeight: "500",
            color: "#080808",

            "&:not(.MuiPickersDay-dayOutsideMonth)": {
              "&.MuiPickersDay-today": {
                borderColor: "#BF295C",
                color: "#BF295C",
                backgroundColor: "white",

                "&.holiday": {
                  borderColor: holidayColor,
                  color: holidayColor,
                  backgroundColor: "white",
                },

                "&.dayOff": {
                  borderColor: dayOffColor,
                  color: dayOffColor,
                  backgroundColor: "white",
                },
              },

              "&.dayOff": {
                backgroundColor: dayOffColor,
                color: "white",
              },

              "&.holiday": {
                backgroundColor: holidayColor,
                color: "white",
              },
            },

            "&.MuiPickersDay-dayOutsideMonth": {
              border: "none !important",
            },
          },

          "& .MuiDayCalendar-weekContainer": {
            margin: "8px 0",
          },

          "& .MuiPickersDay-dayOutsideMonth": {
            color: "#B9B9B9",
          },
        }}
      />
    </Box>
  );
}
